import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FiAppTextSharedModule } from '../app-text';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FiAutofocusModule } from '../fi-directives/autofocus/autofocus.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiObjectEditNamesComponent } from './fi-object-edit-names/fi-object-edit-names.component';
import { FiObjectEditImageComponent } from './fi-object-edit-image/fi-object-edit-image.component';
import { FiObjectEditColorPickerComponent } from './fi-object-edit-color-picker/fi-object-edit-color-picker.component';
import { FiEditObjectDialogComponent } from './fi-edit-object-dialog.component';
import { FiColorPalettePickerModule } from '../fi-color-palette-picker/fi-color-palette-picker.module';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';
@NgModule({
    imports: [
        CommonModule,
        MatTabsModule,
        MatFormFieldModule,
        FiAppTextSharedModule,
        MatInputModule,
        FormsModule,
        FiAutofocusModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        FiColorPalettePickerModule,
        FiValidatingFormModule,
        FiNameInputModule,
    ],
    declarations: [
        FiEditObjectDialogComponent,
        FiObjectEditNamesComponent,
        FiObjectEditImageComponent,
        FiObjectEditColorPickerComponent,
    ],
    exports: [FiEditObjectDialogComponent],
})
export class FiEditObjectDialogModule {}
